/**
 * This file contains AngularJS filters and utility functions related to currency conversion and formatting.
 * 
 * @module app.locale
 * @requires angular
 * @requires app.locale
 * @requires $window
 * @requires moment
 * @requires Exchange
 * @requires $rootScope
 * @requires $state
 * @requires userSvc
 * @requires user_factory
 * @requires CacheFactory
 */
(function () {

    angular.module('app.locale')
        .filter("currencyConverter", ['$window', function ($window) {
            return function (value, currentCurrency, showSymbol, decimalPlaces, isNumber, autoRemoveDecimal, formatLargeNumber) {
                return $window.currencyConverter(value, currentCurrency, showSymbol, decimalPlaces, isNumber, autoRemoveDecimal, formatLargeNumber);
            };
        }]);

    angular.module('app.locale')
        .filter("currencyConverterTrend", ['$window', function ($window) {
            return function (value, currentCurrency, month, year) {
                return (+$window.currencyConverterTrend(value, currentCurrency, month, year)).toLocaleString($window.lang);
            };
        }]);

    angular.module('app.locale')
        .filter("percentConverter", ['$window', function ($window) {
            return function (percent, currentCurrency, month, year, monthBack, price) {
                return $window.percentConverter(percent, currentCurrency, month, year, monthBack, price);
            };
        }]);

    angular.module('app.locale')
        .filter("percent", [function () {
            return function (value, decimalPlaces) {
                value = value || 0;
                decimalPlaces = decimalPlaces || 0;
                return value.toFixed(decimalPlaces) !== 0 ? window.lang !== 'tr' ? (+value.toFixed(decimalPlaces) + '%') : ('%' + value.toFixed(decimalPlaces).replace('.', ',')) : 0;
            };
        }]);

    angular.module('app.locale')
        .filter("decimal", [function () {
            return function (value, decimalPlaces) {
                value = value || 0;
                decimalPlaces = decimalPlaces || 0;
                if (+value % 1 === 0)
                    return window.lang === 'tr' ? (+value).formatMoney(0, ",", ".") : (+value).formatMoney(0, ".", ",");
                else
                    return window.lang === 'tr' ? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(decimalPlaces, ".", ",");
            };
        }]);

    window.currencyIso = function (code) {
        switch (code) {
            case 1:
                return 'TRY';
            case 2:
                return 'USD';
            case 3:
                return 'EUR';
            default:
                return 'TRY';
        }
    };
    window.currencyEndeksaCode = function (code) {
        switch (code) {
            case 'TRY':
                return 1;
            case 'USD':
                return 2;
            case 'EUR':
                return 3;
            default:
                return 1;
        }
    };
    window.currencySymbolByIsoCode = function (code) {
        switch (code) {
            case 'TRY':
                return '₺';
            case 'USD':
                return '$';
            case 'EUR':
                return '€';
            default:
                return '₺';
        }
    };

    window.currencySymbolByEndeksaCode = function (code) {
        switch (code) {
            case 1:
                return '₺';
            case 2:
                return '$';
            case 3:
                return '€';
            default:
                return '₺';
        }
    };

    function formatLargeNumberTr(value, decimalPlaces) {
        function million(){
            return window.lang === "pt-PT" ? "mi" : "M"
        }
        function billion(){
            return window.lang === "pt-PT" ? "bi" : window.lang==="es-ES" ? "MRD" : window.lang === "tr" ? "Mr" : "B"
        }
        function trillion(){
            return window.lang === "pt-PT" ? "tri" : window.lang==="es-ES" ? "B" : window.lang === "tr" ? "Tn" : "T"
        }
        if (+value >= 1e12) {
            return (window.lang === 'tr'? (+value / 1e12).formatMoney(2, ",", ".") : (+value / 1e12).formatMoney(2, ".", ",")) + trillion();
        } else if (+value >= 1e9) {
            return (window.lang === 'tr'? (+value / 1e9).formatMoney(2, ",", ".") : (+value / 1e9).formatMoney(2, ".", ",")) + billion();
        } else if (+value >= 1e6) {
            return (window.lang === 'tr'? (+value / 1e6).formatMoney(2, ",", ".") : (+value / 1e6).formatMoney(2, ".", ",")) + million() ;
        } else {
            return window.lang === 'tr'? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(decimalPlaces, ".", ",");
        }
    }

    // Path: client/app/currencyConverter.js
    // Usage: {{ 100 | currencyConverter:'USD':false:2:true:true }}
    window.currencyConverter = function (value, currentCurrency, addSymbolAfter, decimalPlaces, returnNumber, autoRemoveDecimal, formatLargeNumber) {
        value = value || 0;
        decimalPlaces = decimalPlaces || 0;
        formatLargeNumber = formatLargeNumber || 0;

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        if (window.currencyRates && currentCurrency !== value)
            if (currentCurrency === "TRY") {
                if (window.currency === "USD")
                    value = value / window.currencyRates.usd;
                else if (window.currency === "EUR")
                    value = value / window.currencyRates.eur;
                else
                    value = value;
            }
            else if (currentCurrency === "USD") {
                if (window.currency === "TRY")
                    value = value * window.currencyRates.usd;
                else if (window.currency === "EUR")
                    value = value * window.currencyRates.usd / window.currencyRates.eur;
                else
                    value = value;
            }
            else if (currentCurrency === "EUR") {
                if (window.currency === "TRY")
                    value = value * window.currencyRates.eur;
                else if (window.currency === "USD")
                    value = value * window.currencyRates.eur / window.currencyRates.usd;
                else
                    value = value;
            }

        if (returnNumber)
            return +value.toFixed(decimalPlaces);
        else {
            var result;
            if (autoRemoveDecimal && +value % 1 === 0)
                result = formatLargeNumber && window.currency === "TRY" ? formatLargeNumberTr(+value,0) : window.lang === 'tr' ? (+value).formatMoney(0, ",", ".") : (+value).formatMoney(0, ".", ",");
            else
                result = formatLargeNumber && window.currency === "TRY" ? formatLargeNumberTr(+value,decimalPlaces) : window.lang === 'tr' ? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(0, ".", ",");
            if (addSymbolAfter)
                result = window.lang === 'tr' ? result + ' ' + window.currencySymbol : window.currencySymbol + result;
            return result;
        }
    };

    window.getDatedCurrency = function (month, year) {
        if (window.currencyRatesTrend && window.currencyRatesTrend.length) {
            var found = window.currencyRatesTrend.find(function (item) {
                const rateMonth = +moment(item.rateDate).format("MM");
                const rateYear = +moment(item.rateDate).format("YYYY");
                return rateMonth === month && rateYear === year;
            });
            if (!found) {
                if (+moment(window.currencyRatesTrend[0].rateDate).format("YYYY") >= year)
                    found = window.currencyRatesTrend[0];
                else
                    found = window.currencyRatesTrend[window.currencyRatesTrend.length - 1];
            }
            return found;
        }
        else
            return window.currencyRates;
    };

    window.percentConverter = function (percent, currentCurrency, month, year, monthBack, price) {
        var previous_price = price / (1 + percent / 100);

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        const getDatedCurrency = window.getDatedCurrency(month, year);
        const minusYear = Math.floor(monthBack / 12);
        const minusMonth = monthBack % 12;

        const getPastDatedCurrency = window.getDatedCurrency(month - minusMonth, year - minusYear);

        if (currentCurrency === "TRY") {
            if (window.currency === "USD") {
                price = price / getDatedCurrency.usd;
                previous_price = previous_price / getPastDatedCurrency.usd;
            }
            else if (window.currency === "EUR") {
                price = price / getDatedCurrency.eur;
                previous_price = previous_price / getPastDatedCurrency.eur;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        else if (currentCurrency === "USD") {
            if (window.currency === "TRY") {
                price = price * getDatedCurrency.usd;
                previous_price = previous_price * getPastDatedCurrency.usd;
            }
            else if (window.currency === "EUR") {
                price = price * getDatedCurrency.usd / getDatedCurrency.eur;
                previous_price = previous_price * getPastDatedCurrency.usd / getPastDatedCurrency.eur;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        else if (currentCurrency === "EUR") {
            if (window.currency === "TRY") {
                price = price * getDatedCurrency.eur;
                previous_price = previous_price * getPastDatedCurrency.eur;
            }
            else if (window.currency === "USD") {
                price = price * getDatedCurrency.eur / getDatedCurrency.usd;
                previous_price = previous_price * getPastDatedCurrency.eur / getPastDatedCurrency.usd;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        return  (price / previous_price - 1) * 100;
    }

    window.currencyConverterTrend = function (value, currentCurrency, month, year) {
        value = value || 0;

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        if (window.currencyRatesTrend) {

            const getDatedCurrency = window.getDatedCurrency(month, year);

            if (getDatedCurrency)
                if (currentCurrency === "TRY") {
                    if (window.currency === "USD")
                        value = value / getDatedCurrency.usd;
                    else if (window.currency === "EUR")
                        value = value / getDatedCurrency.eur;
                    else
                        value = value;
                }
                else if (currentCurrency === "USD") {
                    if (window.currency === "TRY")
                        value = value * getDatedCurrency.usd;
                    else if (window.currency === "EUR")
                        value = value * getDatedCurrency.usd / getDatedCurrency.usd;
                    else
                        value = value;
                }
                else if (currentCurrency === "EUR") {
                    if (window.currency === "TRY")
                        value = value * getDatedCurrency.eur;
                    else if (window.currency === "USD")
                        value = value * getDatedCurrency.eur / getDatedCurrency.usd;
                    else
                        value = value;
                }
        }
        return value.toFixed(0);
    };

    angular.module("app.locale").run(['$rootScope', '$window', 'Exchange', '$state', 'userSvc', 'user_factory', 'CacheFactory', function ($rootScope, $window, Exchange, $state, userSvc, user_factory, CacheFactory) {
        $rootScope.assignCurrency = function () {
            var currency = $window.localStorage.getItem('Currency');
            if (!currency) {
                currency = window.lang === 'tr' ? 'TRY' : window.lang === 'en' ? 'USD' : 'EUR';
                $window.localStorage.setItem('Currency', currency);
            }
            $rootScope.currency = currency;
            $rootScope.currencyKey = window.currencyEndeksaCode(currency);
            $rootScope.currencySymbol = window.currencySymbolByIsoCode(currency);
            $window.currencySymbol = $rootScope.currencySymbol
            $window.currency = $rootScope.currency;

            $rootScope.currencySymbolByEndeksaCode = window.currencySymbolByEndeksaCode;

            var date = moment().format('DD.MM.YYYY');
            if (!$window.currencyRates && date) {
                Exchange.currency({ date: date }).$promise.then(function (value) {
                    $window.currencyRates = value;
                });
            }
            if (!$window.currencyRatesTrend) {
                Exchange.trend().$promise.then(function (value) {
                    $window.currencyRatesTrend = value;
                });
            }
            if (userSvc.info.SignedIn) {
                userSvc.info.Details.currency = $rootScope.currencyKey;
                user_factory.currency({ currency: $rootScope.currencyKey }).$promise.finally(function () {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                });
            }
        }

        $rootScope.changeCurrency = function (locale, withoutReload) {
            $window.localStorage.setItem('Currency', locale);
            $rootScope.assignCurrency();
            if (!withoutReload) {
                $state.reload();
            }
        };
    }]);

    angular.module('app.locale')
        .directive('currency', [currency]);

    angular.module('app.locale')
        .directive('currencyTop', [currencyTop]);

    function currency() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<div id="mcurrencyMenu">' +
                '<select selectpicker  ng-model="$root.currency" ng-change="$root.changeCurrency($root.currency)">' +
                '<option ng-selected="$root.currency == \'EUR\'" value="EUR" data-content="<span class=\'currency currency-eur\'>€</span> <span class=\'couname\'>EUR</span>"></option>' +
                '<option ng-selected="$root.currency == \'TRY\'" value="TRY" data-content="<span class=\'currency currency-try\'>₺</span> <span class=\'couname\'>TRY</span>"></option>' +
                '<option ng-selected="$root.currency == \'USD\'" value="USD" data-content="<span class=\'currency currency-usd\'>$</span> <span class=\'couname\'>USD</span>"></option>' +
                '</select>' +
                '</div>'
        };

        return directive;
    }

    function currencyTop() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<ul class="subnav" id="currencyMenu">' +
                '<li class="{{$root.currency == \'EUR\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'EUR\')"><span class="currency currency-eur">€</span> <span class="couname">EUR</span></a></li>' +
                '<li class="{{$root.currency == \'TRY\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'TRY\')"><span class="currency currency-try">₺</span> <span class="couname">TRY</span></a></li>' +
                '<li class="{{$root.currency == \'USD\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'USD\')"><span class="currency currency-usd">$</span> <span class="couname">USD</span></a></li>' +
                '</ul>'
        };

        return directive;
    }
})();